import BlankFavoriteShop from '@components/blank/BlankFavoriteShop';
import BlankShop from '@components/blank/BlankShop';
import Column from '@components/Column';
import InfinityScrollTrigger from '@components/InfinityScrollTrigger';
import Loading from '@components/Loading';
import { ShopInMapRow } from '@models/shop';
import { useAtomValue } from 'jotai';

import ShopItem from './ShopItem';
import styles from './styles.module.scss';
import { isMyShopAtom } from '../../atoms/shopsInMapAtoms';

interface Props {
    isOrder: boolean;
    shops?: ShopInMapRow[];
    fit?: boolean;
    isLoading?: boolean;
    isBlank?: boolean;
    originalItemId?: string;
    fetchNext?: ()=> void;
}

function ShopList({
  isOrder, shops, fit, isLoading, isBlank, originalItemId, fetchNext,
}:Props) {
  const isMyShop = useAtomValue(isMyShopAtom);
  if (isBlank) {
    if (isMyShop) {
      return <BlankFavoriteShop/>;
    }
    return <BlankShop fit={fit}/>;
  }

  return (
        <Column as='section'
                className={styles.container}
                fullWidth>
            <Column as='article' spacing={24}
                    fullWidth >
                {shops?.map((shop) => (
                    <ShopItem key={shop.id}
                              originalItemId={originalItemId}
                              isOrder={isOrder}
                              shop={shop}/>
                ))}
                <InfinityScrollTrigger trigger={fetchNext} />
                {isLoading && (
                    <Column fullWidth align='center'>
                        <Loading size='small' />
                    </Column>
                )}
            </Column>
        </Column>
  );
}

export default ShopList;
